import { createLucideIcon } from 'lucide-react';
var MapPinSolid = createLucideIcon('MapPinSolid', [
    ['path', { d: 'M12 21s-8-6.58-8-12A8 8 0 1 1 20 9c0 5.42-8 12-8 12z', fill: 'currentColor', key: 'pin-body' }],
    ['circle', { cx: '12', cy: '9', fill: 'white', key: 'pin-circle', r: '4' }],
]);
export default MapPinSolid;
